import { AxiosError } from 'axios';

import { CustomerErrorDetailsDtoCodeEnum, CustomerErrorResponseDto } from '@/api/generated';

const CODES = new Set<string>(Object.values(CustomerErrorDetailsDtoCodeEnum));

export const customerErrorUtil = {
  /** The code of a customer approval flow error (Prospekt, Odrzucony klient, Zatwierdzenie klienta). */
  code: (error: unknown): CustomerErrorDetailsDtoCodeEnum | undefined => {
    const code = (error as Partial<AxiosError<Partial<CustomerErrorResponseDto>>>)?.response?.data
      ?.code;
    return code && CODES.has(code) ? code : undefined;
  },
  /** The HTTP status of a failed request, e.g. to tell a 409 or a 403 without a code. */
  httpStatus: (error: unknown): number | undefined =>
    (error as Partial<AxiosError>)?.response?.status,
};
